import axios from '../http'
import {API} from "../const"

const error = (name) => (e) => console.error(name + ':=>', e);

/**
 * 获取钱包余额
 * @param cb
 */
export function getBalanceInfo(cb, fcb = error('getBalanceInfo')) {
    axios.get(API + "/wallet/list").then(response => {
        cb(response.data);
    }).catch(err => {
        fcb(err);
    })
}

export function getBillsInfo(cb, fcb = error('getBalanceInfo')) {
    axios.get(API + "/wallet/trading-flow").then(response => {
        cb(response.data);
    }).catch(err => {
        fcb(err);
    })
}